import { jsx as _jsx } from "react/jsx-runtime";
import { useIFramePage } from 'shared/features/iframe-page';
import { useMember } from 'shared/hooks';
import { PrescriptionsIFrameHeader } from '../components';
import { usePrescriptionsUrl } from './usePrescriptionsUrl';
export var usePrescriptionsIFrame = function (onClose, memberId, appointmentId) {
    var _a, _b, _c;
    var memberData = useMember(memberId).data;
    var _d = usePrescriptionsUrl((_b = (_a = memberData === null || memberData === void 0 ? void 0 : memberData.user) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '', appointmentId), prescriptionsUrlData = _d.data, isLoading = _d.isLoading;
    return useIFramePage({
        iframeUrl: (_c = prescriptionsUrlData === null || prescriptionsUrlData === void 0 ? void 0 : prescriptionsUrlData.ssoUrl) !== null && _c !== void 0 ? _c : null,
        isLoading: isLoading,
        header: function () { return _jsx(PrescriptionsIFrameHeader, { memberId: memberId }); },
        onClose: onClose,
    });
};
